<template>
  <div id="func-16">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao" :voltar="!isWidget"
    />
    <SolicitacaoListagem
      :funcionalidade="funcionalidade"
      :rota-novo="rotaNovo"
      :rota-historico="rotaHistorico"
      :rota-detalhe="rotaDetalhe"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoListagem from '@/components/TemplateSolicitacao/SolicitacaoListagem'

export default {
  name: 'Func16Listagem',
  data () {
    return {}
  },
  components: {
    SolicitacaoListagem,
    FuncionalidadeHeader
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('SetupApp', ['isWidget']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    rotaNovo () {
      return `/${this.funcionalidade.idFuncionalidade}/novo`
    },
    rotaHistorico () {
      return `/${this.funcionalidade.idFuncionalidade}/historico`
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    }
  },
  methods: {
    async init () {
    }
  },
  mounted () {
    this.init()
  }
}
</script>
